module.exports = __webpack_public_path__ + "img/preview-13.4d0d1e64.png";